import {useMutation} from '@tanstack/react-query'
import {useNavigate} from 'react-router-dom'
import {Error, Success} from 'src/feature/bite/helpers/notification'
import useRequestParams from 'src/feature/bite/hook/request'
import {TerminalListSchemaResponse} from '../domain'
import {useTerminal} from '../hook'
import {API} from 'src/feature/bite/domain'

export function useCreateTerminal() {
  const router = useNavigate()
  const {headers, errors} = useRequestParams()

  return useMutation(
    ['TerminalUpdate'],
    async ({values}: {values: any}) => {
      const Response = await fetch(`${API}/Terminal/CreateNewTerminal`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          ...values,
          language: headers.Language,
        }),
      })

      const Data = await Response.json()

      if (!Response.ok || !Data.responseResult.result) {
        Error(Data?.responseResult?.message || errors.terminal.create_error)
        return false
      }

      Success(errors.terminal.create_success)

      setTimeout(() => {
        router('/terminals')
      }, 1000)

      return true
    },
    {
      onSuccess: () => {},
      onError: (error) => {
        Error(errors.terminal.create_error)
      },
    }
  )
}

export function useUpdateTerminal() {
  const router = useNavigate()
  const {headers, errors} = useRequestParams()

  return useMutation(
    ['TerminalUpdate'],
    async ({values}: {values: any}) => {
      const Response = await fetch(`${API}/Terminal/Update`, {
        method: 'PUT',
        headers,
        body: JSON.stringify({
          ...values,
          language: headers.Language,
        }),
      })

      const Data = await Response.json()

      if (!Response.ok || !Data.responseResult.result) {
        Error(Data?.responseResult?.message || errors.terminal.update_error)
        return false
      }

      Success(errors.terminal.update_success)

      setTimeout(() => {
        router(`/terminals/${values.id}`)
      }, 1000)

      return true
    },
    {
      onSuccess: () => {},
      onError: (error) => {
        Error(errors.terminal.update_error)
      },
    }
  )
}

export function useGetAll() {
  const {auth, headers, errorMessage, signOut} = useRequestParams()
  const {list} = useTerminal()

  const userID = auth()?.id

  const listFilter = {
    filterList: [],
    orderList: [{type: 2, key: 'CreatedOn'}],
    paging: {
      currentPageNumber: 1,
      pageSize: list.paging.totalCount,
    },
  }

  return useMutation(
    ['terminalsAll'],
    async () => {
      const Response = await fetch(`${API}/Terminal/GetTerminals`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          userID,
          language: headers.Language,
          // storeId: '996225251718',
          ...listFilter,
        }),
      })

      if (Response.status === 401) {
        signOut()
      }

      const Data = await Response.json()
      const safeParse = TerminalListSchemaResponse.safeParse(Data)
      const parse = TerminalListSchemaResponse.parse(Data)

      if (parse.responseResult.result === false) {
        Error(parse.responseResult.exceptionDetail || errorMessage)
        return []
      }

      if (!safeParse.success) {
        Error(safeParse.error.message)
        return []
      }

      return parse.response.dataList
    },
    {
      onSuccess: () => {},
      onError: (error) => {
        Error(errorMessage)
      },
    }
  )
}
